(function () {
  'use strict';

  const roots = document.querySelectorAll('[data-aic-root]');
  if (!roots.length) return;

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  }[character]));

  roots.forEach((root) => {
    const endpoint = root.dataset.endpoint;
    const form = root.querySelector('[data-aic-form]');
    const input = root.querySelector('[data-aic-input]');
    const submit = root.querySelector('[data-aic-submit]');
    const messagesElement = root.querySelector('[data-aic-messages]');
    const productPanel = root.querySelector('[data-aic-product-panel]');
    const messages = [];
    const sessionKey = 'nmn-architect-ai-session:v1';
    let medicationStatus = 'unknown';
    let awaitingMedicationAnswer = false;
    let awaitingMedicationDetails = false;
    let sessionId;
    try {
      sessionId = sessionStorage.getItem(sessionKey) || crypto.randomUUID();
      sessionStorage.setItem(sessionKey, sessionId);
    } catch (error) {
      sessionId = crypto.randomUUID();
    }

    function scrollToLatest() {
      messagesElement.scrollTop = messagesElement.scrollHeight;
    }

    function currentTime() {
      return new Date().toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' });
    }

    function appendMessage(role, content, extraHtml = '') {
      const turn = document.createElement('div');
      turn.className = `aic__turn aic__turn--${role}`;

      if (role !== 'user') {
        const avatar = document.createElement('span');
        avatar.className = 'aic__mini-avatar';
        avatar.setAttribute('aria-hidden', 'true');
        avatar.innerHTML = `<img src="${escapeHtml(root.dataset.avatarSrc)}" alt="" width="30" height="30">`;
        turn.appendChild(avatar);
      }

      const stack = document.createElement('div');
      stack.className = 'aic__stack';
      const article = document.createElement('article');
      article.className = `aic__message aic__message--${role}`;
      article.innerHTML = `<div>${escapeHtml(content)}</div>${extraHtml}`;
      const time = document.createElement('span');
      time.className = 'aic__time';
      time.textContent = currentTime();
      stack.append(article, time);
      turn.appendChild(stack);
      messagesElement.appendChild(turn);
      scrollToLatest();
      return article;
    }

    function assistantExtras(data) {
      const products = Array.isArray(data.products) ? data.products : [];
      const questions = Array.isArray(data.suggested_questions) ? data.suggested_questions : [];
      const sources = Array.isArray(data.sources) ? data.sources : [];
      return [
        products.length ? `<div class="aic__products">${products.map((product) => `<button type="button" class="aic__product" data-aic-product-handle="${escapeHtml(product.handle)}">Vezi ${escapeHtml(product.name || product.handle)} →</button>`).join('')}</div>` : '',
        questions.length ? `<div class="aic__actions">${questions.map((question) => `<button type="button" class="aic__chip" data-aic-question="${escapeHtml(question)}">${escapeHtml(question)}</button>`).join('')}</div>` : '',
        sources.length ? `<div class="aic__sources">${sources.map((source) => source.url
          ? `<a class="aic__source aic__source--link" href="${escapeHtml(source.url)}" target="_blank" rel="noopener noreferrer">Sursă web: ${escapeHtml(source.filename)} ↗</a>`
          : `<span class="aic__source">Sursă internă: ${escapeHtml(source.filename)}</span>`).join('')}</div>` : '',
      ].join('');
    }

    function formatPrice(cents) {
      return (Number(cents || 0) / 100).toLocaleString('ro-RO', {
        style: 'currency',
        currency: 'RON',
        minimumFractionDigits: Number(cents || 0) % 100 ? 2 : 0,
      });
    }

    function plainDescription(html) {
      const container = document.createElement('div');
      container.innerHTML = String(html || '');
      const text = (container.textContent || '').replace(/\s+/g, ' ').trim();
      return text.length > 320 ? `${text.slice(0, 317).trim()}…` : text;
    }

    async function showProductCard(handle) {
      if (!productPanel || !handle) return;
      productPanel.hidden = false;
      productPanel.innerHTML = '<div class="aic__product-loading">Încarc detaliile și prețul actual…</div>';
      productPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      try {
        const productUrl = `/products/${encodeURIComponent(handle)}`;
        const response = await fetch(`${productUrl}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('product_unavailable');
        const product = await response.json();
        const image = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
        const description = plainDescription(product.description) || 'Deschide pagina produsului pentru ingrediente, utilizare și toate detaliile.';
        const price = Number(product.price || 0);
        const compareAt = Number(product.compare_at_price || 0);
        productPanel.innerHTML = `
          <button type="button" class="aic__product-close" data-aic-product-close aria-label="Închide detaliile produsului">×</button>
          <div class="aic__product-card">
            ${image ? `<img class="aic__product-image" src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
            <div class="aic__product-content">
              <span class="aic__product-label">Detalii produs</span>
              <h3>${escapeHtml(product.title)}</h3>
              <p>${escapeHtml(description)}</p>
              <div class="aic__product-price">${escapeHtml(formatPrice(price))}${compareAt > price ? ` <s>${escapeHtml(formatPrice(compareAt))}</s>` : ''}</div>
              <a class="aic__product-link" href="${escapeHtml(productUrl)}" target="_blank" rel="noopener noreferrer">Vezi toate detaliile ↗</a>
            </div>
          </div>`;
      } catch (error) {
        productPanel.innerHTML = `<button type="button" class="aic__product-close" data-aic-product-close aria-label="Închide detaliile produsului">×</button><p class="aic__product-error">Detaliile produsului nu au putut fi încărcate. <a href="/products/${encodeURIComponent(handle)}" target="_blank" rel="noopener noreferrer">Deschide pagina produsului ↗</a></p>`;
      }
    }

    async function requestAssistant() {
      submit.disabled = true;
      const status = appendMessage('status', 'Caut în materialele NMN România…');

      try {
        if (!endpoint) throw new Error('Chatul nu este încă configurat.');
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: sessionId,
            messages: messages.slice(-12),
            takes_regular_medication: medicationStatus === 'yes',
          }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.ok) throw new Error('Asistentul este momentan indisponibil. Încearcă din nou.');
        const statusTurn = status.closest('.aic__turn');
        if (statusTurn) statusTurn.remove();
        else status.remove();
        messages.push({ role: 'assistant', content: data.answer });
        appendMessage('assistant', data.answer, assistantExtras(data));
      } catch (error) {
        status.textContent = error.message || 'A apărut o eroare. Încearcă din nou.';
      } finally {
        submit.disabled = false;
        input.focus();
      }
    }

    function askMedicationQuestion() {
      awaitingMedicationAnswer = true;
      const question = 'Înainte să-ți fac recomandarea: iei medicamente regulat?';
      messages.push({ role: 'assistant', content: question });
      appendMessage('assistant', question, '<div class="aic__actions"><button type="button" class="aic__chip" data-aic-medication-answer="yes">Da</button><button type="button" class="aic__chip" data-aic-medication-answer="no">Nu</button></div>');
    }

    function answerMedicationQuestion(answer) {
      if (!awaitingMedicationAnswer) return;
      awaitingMedicationAnswer = false;
      medicationStatus = answer === 'yes' ? 'yes' : 'no';
      const label = medicationStatus === 'yes' ? 'Da' : 'Nu';
      root.querySelectorAll('[data-aic-medication-answer]').forEach((button) => { button.disabled = true; });
      messages.push({ role: 'user', content: `Răspuns despre medicație regulată: ${label}.` });
      appendMessage('user', label);

      if (medicationStatus === 'yes') {
        awaitingMedicationDetails = true;
        const question = 'Ce medicamente iei regulat? Scrie doar denumirile; nu avem nevoie de doză sau alte date personale.';
        messages.push({ role: 'assistant', content: question });
        appendMessage('assistant', question);
        input.placeholder = 'Scrie denumirile medicamentelor…';
        input.focus();
        return;
      }
      requestAssistant();
    }

    function ask(content) {
      const trimmed = String(content || '').trim().slice(0, 1800);
      if (!trimmed || submit.disabled) return;

      if (awaitingMedicationAnswer) {
        const normalized = trimmed.toLocaleLowerCase('ro-RO');
        if (['da', 'yes'].includes(normalized)) answerMedicationQuestion('yes');
        else if (['nu', 'no'].includes(normalized)) answerMedicationQuestion('no');
        else appendMessage('assistant', 'Te rog răspunde cu „Da” sau „Nu” folosind butoanele de mai sus.');
        input.value = '';
        return;
      }

      messages.push({ role: 'user', content: trimmed });
      appendMessage('user', trimmed);
      input.value = '';

      if (awaitingMedicationDetails) {
        awaitingMedicationDetails = false;
        input.placeholder = 'Scrie un mesaj…';
        requestAssistant();
        return;
      }

      if (medicationStatus === 'unknown') {
        askMedicationQuestion();
        return;
      }
      requestAssistant();
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      ask(input.value);
    });
    root.addEventListener('click', (event) => {
      const closeProductButton = event.target.closest('[data-aic-product-close]');
      if (closeProductButton) {
        productPanel.hidden = true;
        productPanel.innerHTML = '';
        return;
      }
      const productButton = event.target.closest('[data-aic-product-handle]');
      if (productButton) {
        showProductCard(productButton.dataset.aicProductHandle);
        return;
      }
      const medicationButton = event.target.closest('[data-aic-medication-answer]');
      if (medicationButton) {
        answerMedicationQuestion(medicationButton.dataset.aicMedicationAnswer);
        return;
      }
      const button = event.target.closest('[data-aic-question]');
      if (button) ask(button.dataset.aicQuestion);
    });
  });
}());
